export const statesAndDc = [
  {
    name: 'Alabama',
    usps: 'AL',
    ap: 'Ala.',
    fips: '01',
  },
  {
    name: 'Alaska',
    usps: 'AK',
    ap: 'Alaska',
    fips: '02',
  },
  {
    name: 'Arizona',
    usps: 'AZ',
    ap: 'Ariz.',
    fips: '04',
  },
  {
    name: 'Arkansas',
    usps: 'AR',
    ap: 'Ark.',
    fips: '05',
  },
  {
    name: 'California',
    usps: 'CA',
    ap: 'Calif.',
    fips: '06',
  },
  {
    name: 'Colorado',
    usps: 'CO',
    ap: 'Colo.',
    fips: '08',
  },
  {
    name: 'Connecticut',
    usps: 'CT',
    ap: 'Conn.',
    fips: '09',
  },
  {
    name: 'Delaware',
    usps: 'DE',
    ap: 'Del.',
    fips: '10',
  },
  {
    name: 'District of Columbia',
    usps: 'DC',
    ap: 'D.C.',
    fips: '11',
  },
  {
    name: 'Florida',
    usps: 'FL',
    ap: 'Fla.',
    fips: '12',
  },
  {
    name: 'Georgia',
    usps: 'GA',
    ap: 'Ga.',
    fips: '13',
  },
  {
    name: 'Hawaii',
    usps: 'HI',
    ap: 'Hawaii',
    fips: '15',
  },
  {
    name: 'Idaho',
    usps: 'ID',
    ap: 'Idaho',
    fips: '16',
  },
  {
    name: 'Illinois',
    usps: 'IL',
    ap: 'Ill.',
    fips: '17',
  },
  {
    name: 'Indiana',
    usps: 'IN',
    ap: 'Ind.',
    fips: '18',
  },
  {
    name: 'Iowa',
    usps: 'IA',
    ap: 'Iowa',
    fips: '19',
  },
  {
    name: 'Kansas',
    usps: 'KS',
    ap: 'Kan.',
    fips: '20',
  },
  {
    name: 'Kentucky',
    usps: 'KY',
    ap: 'Ky.',
    fips: '21',
  },
  {
    name: 'Louisiana',
    usps: 'LA',
    ap: 'La.',
    fips: '22',
  },
  {
    name: 'Maine',
    usps: 'ME',
    ap: 'Maine',
    fips: '23',
  },
  {
    name: 'Maryland',
    usps: 'MD',
    ap: 'Md.',
    fips: '24',
  },
  {
    name: 'Massachusetts',
    usps: 'MA',
    ap: 'Mass.',
    fips: '25',
  },
  {
    name: 'Michigan',
    usps: 'MI',
    ap: 'Mich.',
    fips: '26',
  },
  {
    name: 'Minnesota',
    usps: 'MN',
    ap: 'Minn.',
    fips: '27',
  },
  {
    name: 'Mississippi',
    usps: 'MS',
    ap: 'Miss.',
    fips: '28',
  },
  {
    name: 'Missouri',
    usps: 'MO',
    ap: 'Mo.',
    fips: '29',
  },
  {
    name: 'Montana',
    usps: 'MT',
    ap: 'Mont.',
    fips: '30',
  },
  {
    name: 'Nebraska',
    usps: 'NE',
    ap: 'Neb.',
    fips: '31',
  },
  {
    name: 'Nevada',
    usps: 'NV',
    ap: 'Nev.',
    fips: '32',
  },
  {
    name: 'New Hampshire',
    usps: 'NH',
    ap: 'N.H.',
    fips: '33',
  },
  {
    name: 'New Jersey',
    usps: 'NJ',
    ap: 'N.J.',
    fips: '34',
  },
  {
    name: 'New Mexico',
    usps: 'NM',
    ap: 'N.M.',
    fips: '35',
  },
  {
    name: 'New York',
    usps: 'NY',
    ap: 'N.Y.',
    fips: '36',
  },
  {
    name: 'North Carolina',
    usps: 'NC',
    ap: 'N.C.',
    fips: '37',
  },
  {
    name: 'North Dakota',
    usps: 'ND',
    ap: 'N.D.',
    fips: '38',
  },
  {
    name: 'Ohio',
    usps: 'OH',
    ap: 'Ohio',
    fips: '39',
  },
  {
    name: 'Oklahoma',
    usps: 'OK',
    ap: 'Okla.',
    fips: '40',
  },
  {
    name: 'Oregon',
    usps: 'OR',
    ap: 'Ore.',
    fips: '41',
  },
  {
    name: 'Pennsylvania',
    usps: 'PA',
    ap: 'Pa.',
    fips: '42',
  },
  {
    name: 'Rhode Island',
    usps: 'RI',
    ap: 'R.I.',
    fips: '44',
  },
  {
    name: 'South Carolina',
    usps: 'SC',
    ap: 'S.C.',
    fips: '45',
  },
  {
    name: 'South Dakota',
    usps: 'SD',
    ap: 'S.D.',
    fips: '46',
  },
  {
    name: 'Tennessee',
    usps: 'TN',
    ap: 'Tenn.',
    fips: '47',
  },
  {
    name: 'Texas',
    usps: 'TX',
    ap: 'Texas',
    fips: '48',
  },
  {
    name: 'Utah',
    usps: 'UT',
    ap: 'Utah',
    fips: '49',
  },
  {
    name: 'Vermont',
    usps: 'VT',
    ap: 'Vt.',
    fips: '50',
  },
  {
    name: 'Virginia',
    usps: 'VA',
    ap: 'Va.',
    fips: '51',
  },
  {
    name: 'Washington',
    usps: 'WA',
    ap: 'Wash.',
    fips: '53',
  },
  {
    name: 'West Virginia',
    usps: 'WV',
    ap: 'W.Va.',
    fips: '54',
  },
  {
    name: 'Wisconsin',
    usps: 'WI',
    ap: 'Wis.',
    fips: '55',
  },
  {
    name: 'Wyoming',
    usps: 'WY',
    ap: 'Wyo.',
    fips: '56',
  },
];
